export default __webpack_public_path__ + "static/5905v5907_thumb-964c74970aa9a7ba0c624e80f07f0a29.png";